import _ from "lodash";
import React from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";

// Shared "Represents" picker. Callers supply the qapi `resource`, `select` columns, and a
// `toOption` mapper to { label, value, imageUrl, subtitle }; each option renders avatar + name +
// optional subtitle.
function formatOption(option) {
  return (
    <div className="d-flex align-items-center">
      <ImageCropped roundedCircle src={option.imageUrl} alt={option.label} size={30} fallbackToInitials />
      <span className="ms-2 fw-bold">{option.label}</span>
      {option.subtitle && <span className="ms-2 text-secondary">| {option.subtitle}</span>}
    </div>
  );
}

function loadOptions({ resource, select, toOption, idsToExclude }) {
  return async (query, _loadOptions, { page, perPage }) => {
    try {
      const { data, remainingRows } = await resource.getAll({
        query,
        page,
        perPage,
        select,
        exclude: idsToExclude,
      });
      const options = (_.isEmpty(data) ? [] : data).map(toOption);

      return {
        options,
        hasMore: remainingRows > 0,
        additional: { page: page + 1, perPage },
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error loading options:", error);
      return {
        options: [],
        hasMore: false,
        additional: { page, perPage },
      };
    }
  };
}

function EntityPicker({ resource, select, toOption, idsToExclude, onPicked, onKeyDown, selectRef }) {
  return (
    <AsyncPaginate
      className="form-control border-0"
      placeholder="Type to search…"
      loadOptions={loadOptions({ resource, select, toOption, idsToExclude })}
      formatOptionLabel={formatOption}
      additional={{ page: 1, perPage: 12 }}
      debounceTimeout={300}
      onChange={({ value: id }) => onPicked(id)}
      selectRef={selectRef}
      onKeyDown={onKeyDown}
    />
  );
}

export default EntityPicker;
